import { RotateCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface DataTableRefreshButtonProps {
  onRefresh?: () => void;
  isRefreshing?: boolean;
  disabled?: boolean;
  className?: string;
}

export function DataTableRefreshButton({
  onRefresh,
  isRefreshing = false,
  disabled = false,
  className,
}: DataTableRefreshButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          onClick={() => onRefresh?.()}
          disabled={isRefreshing || disabled}
          className={className}
        >
          <RotateCw className={`${isRefreshing && "animate-spin"}`} />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Refresh</TooltipContent>
    </Tooltip>
  );
}
